import React from 'react';
import Icon from '../../../components/AppIcon';

const OptimizationPanel = ({ qualityScore, suggestions }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getScoreLabel = (score) => {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    if (score >= 40) return 'Fair';
    return 'Needs Improvement';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Prompt Quality Analysis</h3>
        {qualityScore !== null && (
          <div className="flex items-center gap-2">
            <span className={`text-2xl font-bold ${getScoreColor(qualityScore)}`}>
              {qualityScore}
            </span>
            <span className="text-sm text-muted-foreground">/ 100</span>
          </div>
        )}
      </div>
      {qualityScore !== null ? (
        <>
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Quality Rating</span>
              <span className={`font-semibold ${getScoreColor(qualityScore)}`}>
                {getScoreLabel(qualityScore)}
              </span>
            </div>
            <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
              <div
                className={`h-full transition-all duration-500 ${
                  qualityScore >= 80 ? 'bg-success' : qualityScore >= 60 ? 'bg-warning' : 'bg-error'
                }`}
                style={{ width: `${qualityScore}%` }}
              />
            </div>
          </div>

          {suggestions && suggestions?.length > 0 && (
            <div className="space-y-3">
              <h4 className="text-sm font-semibold text-foreground">Improvement Suggestions</h4>
              <div className="space-y-2">
                {suggestions?.map((suggestion, index) => (
                  <div key={index} className="flex items-start gap-2 p-3 bg-muted rounded-lg">
                    <Icon
                      name={suggestion?.type === 'warning' ? 'AlertCircle' : 'Info'}
                      size={16}
                      className={`${
                        suggestion?.type === 'warning' ? 'text-warning' : 'text-primary'
                      } mt-0.5 flex-shrink-0`}
                    />
                    <p className="text-sm text-foreground">{suggestion?.text}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="grid grid-cols-2 gap-3 pt-2">
            <div className="p-3 bg-muted rounded-lg">
              <div className="flex items-center gap-2 mb-1">
                <Icon name="Target" size={16} className="text-primary" />
                <span className="text-xs font-medium text-muted-foreground">Clarity</span>
              </div>
              <span className="text-lg font-semibold text-foreground">
                {Math.min(100, qualityScore + 5)}%
              </span>
            </div>
            <div className="p-3 bg-muted rounded-lg">
              <div className="flex items-center gap-2 mb-1">
                <Icon name="Zap" size={16} className="text-primary" />
                <span className="text-xs font-medium text-muted-foreground">Specificity</span>
              </div>
              <span className="text-lg font-semibold text-foreground">
                {Math.max(0, qualityScore - 5)}%
              </span>
            </div>
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center py-8">
          <p className="text-muted-foreground text-center">
            Generate a prompt to see quality analysis
          </p>
        </div>
      )}
    </div>
  );
};

export default OptimizationPanel;